import React from 'react';
import { Page } from './page';

import Player from '../functions/player';
import { GameInfo } from '../components/gameInfo';
import { Restore } from '../components/restore';

export class Introduction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      partOfGame: 13,
      timerOver: false,
      video: '/game/untracked/introduction.mp4', // require("../assets/videos/video.mp4")
    }
  }

  nextRound = () => {
    this.refs.GameInfo.nextRound();
    return;
  }

  componentWillMount(){
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    const currentPart = Player.getData('partOfGame');

    this.setState({
      partOfGame: currentPart,
    });
  }

  onVideoClick = () => {
    const video = this.refs.video;
    video.paused?video.play():video.pause();
  }

  render() {
    return(
      <Page width="superWide" pageTitle="Intro" imageSet="3">
        <Restore />
        <div className="videoPage">
          <GameInfo ref="GameInfo" part={this.state.partOfGame} getGameScreen={() => {return this.props.location.pathname}} />
          <video onClick={this.onVideoClick} ref="video" autoPlay="true" controls>
            <source src={this.state.video} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          <button className="bigButton" onClick={this.nextRound}>Skip video</button>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/introduction.js